"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserService = void 0;
let cache;
class UserService {
    constructor() {
        this.get = async () => {
            const result = { data: cache, errors: [] };
            const location = window.location.href;
            const subdomain = /^(http|https):\/\/www\.ameriprise.com\//.test(location)
                ? 'secure'
                : 'secure-01.qa';
            const userService = `https://${subdomain}.ameriprise.com/scs.svc/User(usrCtx='SSO.GUID',usrId='0'`;
            if (!cache && cache !== false) {
                try {
                    const response = await this.fetchJSON(`${userService})?$expand=client&$format=json`);
                    if (!response.ok) {
                        const error = new Error(`HTTP error: ${response.status}`);
                        error.status = response.status;
                        throw error;
                    }
                    const data = await response.json();
                    const { clCtx, clId } = data?.d?.client ?? {};
                    const person = data?.d?.client?.person ?? {};
                    const { usrCtx, usrId } = data?.d ?? {};
                    cache = {
                        client: {
                            ctx: clCtx,
                            id: clId,
                            user: person
                        },
                        usrCtx,
                        usrId
                    };
                    result.data = cache;
                }
                catch (error) {
                    result.data = null;
                    result.errors = [
                        error instanceof Error ? error : new Error(String(error))
                    ];
                    cache = false;
                }
            }
            return result;
        };
        this.fetchJSON = (url) => {
            return fetch(url, {
                mode: 'cors',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });
        };
        this.clearCache = () => {
            cache = null;
        };
    }
}
exports.UserService = UserService;
